import { FF_BLOCK_ANTHROPIC_MODELS_ANY_LLM } from '@/consts/featureFlags';
import { posthog } from '@/providers/posthog';
/**
 * HOTFIX: remove anthropic models from any llm model for this client
 * Once we have an option to block certain models inside any_llm in the models management, we can remove this
 */
export const removeAnthropicModelsIfNeeded = (models: string[]) => {
  if (posthog.isFeatureEnabled(FF_BLOCK_ANTHROPIC_MODELS_ANY_LLM) && models?.length > 0) {
    return models.filter((model) => !model.includes('anthropic'));
  }
  return models;
};
